import { render } from "./ImageElement.vue?vue&type=template&id=5318d72e&scoped=true"
import script from "./ImageElement.vue?vue&type=script&lang=js"
export * from "./ImageElement.vue?vue&type=script&lang=js"

import "./ImageElement.vue?vue&type=style&index=0&id=5318d72e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5318d72e"]])

export default __exports__